import "reflect-metadata";
import {inject, injectable} from "inversify";
import {ChatRepository} from "@dropDesk/domain/repositories/chat/chat.repository";
import {ListPaginationEntity} from "@dropDesk/domain/entities/common/list_pagination.entity";
import {TicketEntity} from "@dropDesk/domain/entities/ticket/ticket.entity";
import {Observable} from "rxjs";

@injectable()
export class SubscribeChatsUseCase {
    private _repository: ChatRepository;

    constructor(@inject(ChatRepository) repository: ChatRepository) {
        this._repository = repository;
    }

    public call(handleDisconnect: (temporary: boolean) => void, getLastUpdates: () => void, id?: string, ticket?:TicketEntity | null): Observable<TicketEntity[]> {
        return this._repository.subscribe(handleDisconnect, getLastUpdates, id, ticket);
    }
}

